import { IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";
import { eventStatuses, peopleBlockStatuses } from "Bands/utils";
import { IIconBandSetting } from "Bands/types";
import { getIcon } from "shared/utils";
import { API_ENDPOINTS } from "shared/constants";

const { errors } = copy;
const icalFields = copy.calendar.iCalExport.fields;

export const getFields = ({ eventTypes }: { eventTypes: IIconBandSetting[] }): IFormFields => [
  {
    name: "eventRsvpStatuses",
    label: icalFields.eventRSVPStatuses,
    type: IFieldType.tagGroup,
    options: peopleBlockStatuses,
    isMultiple: true,
    showViewLabel: true,
  },
  {
    name: "eventStatuses",
    label: icalFields.eventStatuses,
    type: IFieldType.tagGroup,
    options: eventStatuses,
    isMultiple: true,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "eventTypes",
    label: icalFields.eventTypes,
    type: IFieldType.tagGroup,
    options: eventTypes?.map(({ icon, id, label }) => ({
      label: label,
      value: API_ENDPOINTS.EVENT_TYPES(id),
      icon: getIcon(icon),
    })),
    isMultiple: true,
    validation: {
      required: errors.required,
    },
  },
];
